<template>
  <a-form v-bind="formItemLayout" labelAlign="left" :colon="false" class="form-detail">
    <a-row>
      <a-col v-for="{ key, label, width } in historyDetailFilter" :key="key" :span="width === 100 ? 24 : 12">
        <a-form-item :label="label">
          <a-row>
            <!-- eslint-disable vue/no-v-text-v-html-on-component -->
            <a-col :span="24" v-html="generateValue(key)" />
            <template v-if="key === 'updatedBy'">
              <a-col :span="24">
                {{ generateValue("modifiedDateFormat") }}
              </a-col>
            </template>
            <template v-else-if="key === 'createdByName'">
              <a-col :span="24">
                {{ generateValue("createdDateFormat") }}
              </a-col>
            </template>
          </a-row>
        </a-form-item>
      </a-col>
    </a-row>
  </a-form>
</template>

<script>
import {
  ACTION_CREATED_TYPE,
  ACTION_EDITED_TYPE,
  GENERAL_CONFIGURATION,
  LEAVE_CARRYOVER_SCREEN,
  POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN,
  PROJECT_LEAVE_DETAIL_SCREEN,
} from "@/utils";
import {
  ADVANCE_LEAVE,
  CONDITION_MONTH,
  EXTRA_FOR_LOYALTY,
  LEAVE_HOUR_IN_MONTH,
  // OBJECT,
} from "@/pages/AnnualLeave/constants";
import {
  EXPLANATION_RULE_KEY,
  OT_TYPE_KEY,
  URL_POLICY_KEY,
  WORK_SCHEDULE_CODE_KEY,
  WORK_SCHEDULE_TYPE_KEY,
} from "@/pages/PolicyManagement/constants";
const historyDetail = [
  {
    key: "fullName",
    label: "Name",
    width: 100,
    pages: [LEAVE_CARRYOVER_SCREEN, PROJECT_LEAVE_DETAIL_SCREEN, POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
  },
  {
    key: "financialYear",
    label: "Financial Year",
    width: 100,
    pages: [LEAVE_CARRYOVER_SCREEN],
  },
  {
    key: "projectName",
    label: "Project",
    width: 100,
    pages: [PROJECT_LEAVE_DETAIL_SCREEN],
  },
  {
    key: "leaveHours",
    label: "Leave Hour (s)",
    width: 100,
    pages: [LEAVE_CARRYOVER_SCREEN],
  },
  {
    key: "leaveDay",
    label: "Leave Day (s)",
    width: 100,
    pages: [PROJECT_LEAVE_DETAIL_SCREEN],
  },
  {
    key: "description",
    label: "Note",
    width: 100,
    pages: [LEAVE_CARRYOVER_SCREEN],
  },
  {
    key: WORK_SCHEDULE_CODE_KEY,
    label: "Work Schedule",
    width: 100,
    pages: [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
  },
  {
    key: WORK_SCHEDULE_TYPE_KEY,
    label: "Work Schedule Type",
    width: 100,
    pages: [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
  },
  {
    key: EXPLANATION_RULE_KEY,
    label: "Explanation Rule",
    width: 100,
    pages: [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
  },
  {
    key: OT_TYPE_KEY,
    label: "Overtime Rule",
    width: 100,
    pages: [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
  },
  {
    key: URL_POLICY_KEY,
    label: "Policy Link",
    width: 100,
    pages: [POLICY_MANAGEMENT_EMPLOYEE_HISTORY_SCREEN],
    customRender(value) {
      return value ? `<a href="${value}" target="_blank" style="color: #0379B0">Link</a>` : "";
    },
  },
  // {
  //   key: OBJECT,
  //   label: "Object",
  //   width: 100,
  //   pages: [GENERAL_CONFIGURATION],
  // },
  {
    key: EXTRA_FOR_LOYALTY,
    label: "Extra for loyalty",
    width: 100,
    pages: [GENERAL_CONFIGURATION],
  },
  {
    key: CONDITION_MONTH,
    label: "Condition/ Month",
    width: 100,
    pages: [GENERAL_CONFIGURATION],
  },
  {
    key: LEAVE_HOUR_IN_MONTH,
    label: "Annual Hour(s)/ Month",
    width: 100,
    pages: [GENERAL_CONFIGURATION],
  },
  {
    key: ADVANCE_LEAVE,
    label: "Advanced leave",
    width: 100,
    pages: [GENERAL_CONFIGURATION],
  },
  {
    key: "applyDateFormat",
    label: "Date Applied",
    width: 100,
  },
  {
    key: "expireDateFormat",
    label: "Date Expired",
    width: 100,
  },
  {
    key: "updatedBy",
    label: "Updated By",
    width: 100,
    action: ACTION_EDITED_TYPE,
  },
  {
    key: "createdByName",
    label: "Created By",
    width: 100,
    action: ACTION_CREATED_TYPE,
  },
];
export default {
  name: "HistoryDetail",
  props: {
    data: {
      type: Object,
      default: () => null,
    },
    page: {
      type: String,
      default: LEAVE_CARRYOVER_SCREEN,
    },
  },
  computed: {
    historyDetailFilter() {
      const { data } = this;
      if (data) {
        return historyDetail?.filter(
          (item) => (item.pages?.includes(this.page) || !item.pages) && (item.action === data.action || !item.action)
        );
      }
      return historyDetail?.filter((item) => item.pages?.includes(this.page) || !item.pages);
    },
  },
  data() {
    return {
      formItemLayout: {
        labelCol: { span: 8 },
        wrapperCol: { span: 15, offset: 1 },
      },
      historyDetail,
    };
  },
  methods: {
    generateValue(key) {
      const { data } = this;
      if (!data) return "";
      if (key === "leaveHours") {
        return `${data?.[key] ?? 0} hour(s)`;
      } else if (key === "leaveDay") {
        return `${data?.[key] ?? 0} day(s)`;
      } else if (key === URL_POLICY_KEY) {
        return data?.[key] ? `<a href="${data?.[key]}" target="_blank" style="color: #0379B0">Link</a>` : "";
      }
      return data?.[key] ?? "";
    },
  },
};
</script>

<style lang="scss" scoped>
.form-detail {
  .ant-form-item {
    border-bottom: 2px solid #cdebf9;
    padding: 6px 0px;
    margin-bottom: 0;
    ::v-deep label {
      line-height: 24px;
      color: #61757d;
    }
    ::v-deep .ant-form-item-children {
      color: #29444f;
    }
  }
}
</style>
